import { type ComponentProps, type FC, useId } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button, FormControl, FormLabel } from 'base-ui'

import { StoryblokBmiCalculatorNumberInput } from './StoryblokBmiCalculatorNumberInput'

type StoryblokBmiCalculatorFormProps = Omit<
  ComponentProps<'form'>,
  'children' | 'className' | 'noValidate'
>

export const StoryblokBmiCalculatorForm: FC<StoryblokBmiCalculatorFormProps> = (
  props,
) => {
  const heightId = useId()
  const weightId = useId()

  return (
    <form className="flex flex-col gap-4" noValidate {...props}>
      <FormControl>
        <FormLabel htmlFor={heightId}>
          <FormattedMessage id="bmi.calculator.label.height" />
        </FormLabel>
        <StoryblokBmiCalculatorNumberInput
          name="height"
          slotProps={{ input: { id: heightId } }}
        />
      </FormControl>
      <FormControl>
        <FormLabel htmlFor={weightId}>
          <FormattedMessage id="bmi.calculator.label.weight" />
        </FormLabel>
        <StoryblokBmiCalculatorNumberInput
          name="weight"
          slotProps={{ input: { id: weightId } }}
        />
      </FormControl>
      <Button type="submit">
        <FormattedMessage id="bmi.calculator.label.calculate" />
      </Button>
    </form>
  )
}
